import { IntegrationCard } from './IntegrationCard';
import { IntegrationTile } from './integrationLogos';
import { useState } from 'react';
import {
  useConnectFigma,
  useFigmaToken,
  useRemoveFigmaToken,
} from '../../hooks/useFigmaToken';

function FigmaIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 38 57" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M19 28.5C19 23.2533 23.2533 19 28.5 19C33.7467 19 38 23.2533 38 28.5C38 33.7467 33.7467 38 28.5 38C23.2533 38 19 33.7467 19 28.5Z" fill="#1ABCFE"/>
      <path d="M0 47.5C0 42.2533 4.25329 38 9.5 38H19V47.5C19 52.7467 14.7467 57 9.5 57C4.25329 57 0 52.7467 0 47.5Z" fill="#0ACF83"/>
      <path d="M19 0V19H28.5C33.7467 19 38 14.7467 38 9.5C38 4.25329 33.7467 0 28.5 0H19Z" fill="#FF7262"/>
      <path d="M0 9.5C0 14.7467 4.25329 19 9.5 19H19V0H9.5C4.25329 0 0 4.25329 0 9.5Z" fill="#F24E1E"/>
      <path d="M0 28.5C0 33.7467 4.25329 38 9.5 38H19V19H9.5C4.25329 19 0 23.2533 0 28.5Z" fill="#A259FF"/>
    </svg>
  );
}

export function FigmaIntegrationCard() {
  const { data: tokenData, isLoading } = useFigmaToken();
  const connectMutation = useConnectFigma();
  const removeMutation = useRemoveFigmaToken();

  const [actionError, setActionError] = useState<string | null>(null);

  const isConnected = !!tokenData?.accessToken;
  const isConnecting = connectMutation.isPending;

  const handleConnect = () => {
    setActionError(null);
    connectMutation.mutate(undefined, {
      onError: () => {
        setActionError('Failed to start Figma connection. Try again.');
      },
    });
  };

  const handleDisconnect = async () => {
    setActionError(null);
    try {
      await removeMutation.mutateAsync();
    } catch {
      setActionError('Failed to disconnect Figma. Try again.');
    }
  };

  const user = tokenData?.user;
  return (
    <IntegrationCard
      provider="figma"
      loading={isLoading}
      tile={<IntegrationTile color="var(--oq-palette-neutral-900)"><FigmaIcon /></IntegrationTile>}
      name="Figma"
      description="Compare designs against live pages and sync Figma comments."
      connection={{
        connected: isConnected,
        connecting: isConnecting,
        disconnecting: removeMutation.isPending,
        onConnect: handleConnect,
        onDisconnect: () => void handleDisconnect(),
        rows: [['Account', user ? [user.handle, user.email].filter(Boolean).join(', ') : null]],
      }}
      errors={[actionError]}
    />
  );
}
